// export const URL_PREFIX = (process.env==='development') ? '/api' : ' http://localhost:8080/wosai';
export function dateFormat(d) { //时间转换
  return d.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4:$5:$6');
}
//转换日期
export function formatDateTime(theDate, type) {
  let _hour = theDate.getHours();
  let _minute = theDate.getMinutes();
  let _second = theDate.getSeconds();
  let _year = theDate.getFullYear() + '';
  let _month = theDate.getMonth();
  let _date = theDate.getDate();
  if (_hour < 10) {
    _hour = "0" + _hour;
  }
  if (_minute < 10) {
    _minute = "0" + _minute;
  }
  if (_second < 10) {
    _second = "0" + _second;
  }
  _month = _month + 1;
  if (_month < 10) {
    _month = "0" + _month;
  }
  if (_date < 10) {
    _date = "0" + _date;
  }
  switch (type) {
    case 'year':
      return _year;
      break;
    case 'month':
      return _year + _month;
      break;
    case 'date':
      return _year + _month + _date;
      break;
    case 'time':
      return _hour + _minute + _second;
      break;
    case 'datetime':
      return _year + _month + _date + _hour + _minute + _second;
      break;
    default:
      return _year + _month + _date + _hour + _minute + _second;
  }
}

/**
 * 显示载入提示文字 id是外部id url是页面相对于图片的路径
 * @param selectors
 * @param msg
 * @param url
 */
export function showLoading(selectors, msg, url) {
  let target = selectors ? document.querySelector(selectors) : $("body");
  let offset = target.offset();
  url = url || require("../../../static/img/loading.gif");
  msg = msg || '';
  let $loading = $('<div id="common_loading" style="position:absolute;z-index:9999"></div>');
  $loading.append($('<img src="' + url + '" style="width:50px;height:50px"/>'));
  $loading.append($('<span style="color:gray;font-size:1rem;margin-left:0.3rem">' + msg + '</span>'));
  target.append($loading);
  $loading.css("top", "50%");
  $loading.css("left", "50%");
  // $loading.css("top",offset.height/2);
  // $loading.css("left",offset.width/2-$loading.width()/2);
}

/**
 * 隐藏loading
 */
export function hideLoading() {
  $("#common_loading").remove();
}



// WEBPACK FOOTER //
// ./src/components/common/common.js